/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Item reducer
 */

import _isEqual from "lodash/isEqual";
import _merge from "lodash/merge";
import { createReducer } from "@reduxjs/toolkit";
import { fetchShowcaseKits } from "@actions/kits/useShowcaseKits";

type Data = {
  kits?: Record<string, string>;
  items?: Record<string, string>;
  sections?: Record<string, string>;
  portals?: Record<string, string>;
};

const shortIdReducer = createReducer<Data>({}, builder => {
  builder
    .addCase(fetchShowcaseKits.fulfilled, () => {
      // Do nothing
    })
    .addDefaultCase((state, action: any) => {
      const entities = action.payload?.entities ?? action.response?.entities;
      if (!entities) return state;
      const updates = getShortIdsFromEntities(entities);
      // Only merge if there's actually new data
      const hasChanges = Object.keys(updates).some(key => {
        const incoming = updates[key];
        const existing = state[key as keyof Data];
        if (!existing) return true;
        return Object.keys(incoming).some(id => !_isEqual(existing[id], incoming[id]));
      });
      if (hasChanges) {
        return _merge(state, updates);
      }
      return state;
    });
});

type Entities = {
  [key: string]: {
    [key: string]: { id?: number; kitId?: string; shortId?: string };
  };
};
const getShortIdsFromEntities = (entities: Entities): Record<string, Record<string, string>> => {
  const objectMap = {
    sections: { key: "id", type: "sections" },
    items: { key: "id", type: "items" },
    kits: { key: "kitId", type: "kits" },
    portals: { key: "id", type: "portals" },
  };

  return Object.keys(entities).reduce((res, entitityType) => {
    // We only care object types with an id mapping defined above
    const mapping = objectMap[entitityType];
    if (!mapping) return res;
    const { key, type } = mapping;

    const objects = Object.values(entities[entitityType].objects ?? entities[entitityType]);
    res[type] = objects.reduce((objAcc, obj) => {
      // This check ensures values because inserting null or undefined values would produce strange bugs
      if (!obj[key] || !obj.shortId)
        throw new Error(`${type} object missing expected shortID or ${key}`);
      objAcc[obj.shortId] = obj[key];
      return objAcc;
    }, res[type] || {});
    return res;
  }, {});
};

export default shortIdReducer;
